<template>
  <div class="container-fluid mt-5">
    <div class="row">
      <div class="col-xl-12 order-xl-1">
        <card>
          <div slot="header" class="row align-items-center">
            <div class="col-8">
              <h3 class="mb-0">Nuevo mensaje</h3>
            </div>
            <div class="col-4 text-right">
              <base-button
                @click="goBack"
                type="button"
                class="btn btn-sm btn-primary"
                >Atrás</base-button
              >
            </div>
          </div>
          <div class="card-body">
            <form @submit.prevent="handleSubmit">
              <p class="card-text">
                Escribe tu mensaje para
                <b>{{ this.user.nombre }} {{ this.user.apellidos }}</b>
              </p>
              <base-input>
                <textarea
                  class="form-control"
                  v-model="notificacion.descripcion"
                  rows="8"
                  placeholder="Escribe aquí tu mensaje..."
                ></textarea>
              </base-input>

              <div style="margin-top: 40px">
                <span
                  slot="footer"
                  class="dialog-footer"
                  style="margin-top: 20px"
                >
                  <base-button
                    @click="dialogFormVisible = false"
                    type="secondary"
                    style="margin-right: 8"
                    >Cancelar</base-button
                  >

                  <base-button
                    type="primary"
                    native-type="submit"
                    style="margin: 0; padding-left: 50px; padding-right: 50px"
                  >
                    Enviar
                  </base-button>
                </span>
              </div>
            </form>
          </div>
        </card>
      </div>
    </div>
  </div>
</template>
<script>
import ValidationError from "@/components/ValidationError.vue";
import formMixin from "@/mixins/form-mixin";
import BaseInput from "@/components/Inputs/BaseInput.vue";
import { Select, Option, Table, TableColumn } from "element-ui";
import { cloneDeep } from "lodash";
import moment from "moment";

export default {
  layout: "DashboardLayout",
  components: {
    BaseInput,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
  },
  mixins: [formMixin],

  data() {
    return {
      available_tipos: [],
      available_empresas: [],
      available_revisores: [],
      available_estados: [],
      multipleSelection: [],
      user: {},

      notificacion: {
        type: "notificaciones",
        descripcion: null,
        estado_notificacion: {
          id: 1,
        },
        tipo_notificacion: {
          id: 5,
        },
        usuario_origen: {
          id: null,
        },
        usuario_destinos: [],
        empresa: {
          id: null,
        },
      },
    };
  },

  created() {
    this.getUsuario();
  },

  watch: {
    /*  color: {
      handler: "updateTagColor",
      immediate: true,
      deep: true,
    }, */
  },

  methods: {
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    async handleSubmit() {
      this.notificacion.usuario_destinos = [this.user];
      console.log("NOTIFICACIÓN: ");
      console.log(this.notificacion);

      try {
        await this.$store.dispatch("notificaciones/add", this.notificacion);
        this.$notify({
          type: "success",
          message: "Se ha enviado la notificación correctamente.",
        });
        this.goBack();
      } catch (error) {
        this.$notify({
          type: "danger",
          message: "Oops, algo ha ido mal",
        });
        this.setApiValidation(error.response.data.error.details.errors);
      }
    },

    async getTipos() {
      try {
        this.$store.dispatch("tiposNotificacion/list").then(() => {
          this.available_tipos = cloneDeep(
            this.$store.getters["tiposNotificacion/dropdown"]
          );
          this.available_tipos.forEach((element) => {});
        });
      } catch (error) {
        this.$notify({
          type: "danger",
          message: `Oops, something went wrong!`,
        });
        this.setApiValidation(error.response.data.errors);
      }
    },

    async getUsuario() {
      var planta = localStorage.getItem("plantaSelected");

      await this.$store.dispatch("profile/me");

      try {
        let profile = await this.$store.getters["profile/me"];
        console.log(profile);

        this.notificacion.usuario_origen.id = profile.id;

        var empresas = [];
        profile.empresas.forEach((element) => {
          empresas.push(element.id);
        });

        if (planta != 0) {
          empresas = [planta];
        }
        this.notificacion.empresa.id = planta;

        const id = this.$route.params.id;
        await this.$store.dispatch("users/get", id);
        this.user = this.$store.getters["users/user"];
      } catch (error) {
        this.$notify({
          type: "danger",
          message: `Oops, something went wrong!`,
        });
        this.setApiValidation(error.response.data.errors);
      }
    },

    async getEstados() {
      try {
        this.$store.dispatch("estadosNotificacion/list").then(() => {
          this.available_estados = cloneDeep(
            this.$store.getters["estadosNotificacion/dropdown"]
          );
          this.available_estados.forEach((element) => {});
        });
      } catch (error) {
        this.$notify({
          type: "danger",
          message: `Oops, something went wrong!`,
        });
        this.setApiValidation(error.response.data.errors);
      }
    },

    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
